if($('.dropdown').length) {
    $('.dropdown button').on('click', function(e) {
        e.stopPropagation();
        $(this).parent().toggleClass('active');
        $(this).parent().find('.dropdown-menu').slideToggle();

        $('.dropdown').not($(this).parent()).removeClass('active');
        $('.dropdown').not($(this).parent()).find('.dropdown-menu').slideUp();
    });

    $('body').on('click', function(e) {
        if(!$(e.target).closest('.dropdown').length) {
            $('.dropdown').removeClass('active');
            $('.dropdown-menu').slideUp();
        }
    });

    $('.dropdown .dropdown-menu').on('click', function(e) {
        e.stopPropagation();
    });
}
